export var NodeType;
(function (NodeType) {
    NodeType["POPULATION"] = "population";
    NodeType["DYNAMIC"] = "dynamic";
    NodeType["VARIABLE"] = "variable";
})(NodeType || (NodeType = {}));
export var CellModelEntityConnectionType;
(function (CellModelEntityConnectionType) {
    CellModelEntityConnectionType["POPULATION_EFFECT"] = "populationEffect";
    CellModelEntityConnectionType["EFFECT_ON_VARIABLE"] = "effectOnVariable";
    CellModelEntityConnectionType["DEPENDENCY"] = "dependency";
})(CellModelEntityConnectionType || (CellModelEntityConnectionType = {}));
export var EdgeDirection;
(function (EdgeDirection) {
    EdgeDirection["Left"] = "left";
    EdgeDirection["Right"] = "right";
})(EdgeDirection || (EdgeDirection = {}));
export var DynamicPropKeys;
(function (DynamicPropKeys) {
    DynamicPropKeys["type"] = "type";
    DynamicPropKeys["mean"] = "mean";
    DynamicPropKeys["sd"] = "sd";
    DynamicPropKeys["from"] = "from";
    DynamicPropKeys["to"] = "to";
    DynamicPropKeys["value"] = "value";
})(DynamicPropKeys || (DynamicPropKeys = {}));
export var DynamicRestrictionKeys;
(function (DynamicRestrictionKeys) {
    DynamicRestrictionKeys["type"] = "Type";
    DynamicRestrictionKeys["mean"] = "Mean";
    DynamicRestrictionKeys["sd"] = "SD";
    DynamicRestrictionKeys["from"] = "From";
    DynamicRestrictionKeys["to"] = "To";
    DynamicRestrictionKeys["value"] = "Value";
})(DynamicRestrictionKeys || (DynamicRestrictionKeys = {}));
export var DynamicType;
(function (DynamicType) {
    DynamicType["DISTRIBUTION"] = "Distribution";
    DynamicType["FIXED"] = "Fixed";
    DynamicType["RANGE"] = "Range";
})(DynamicType || (DynamicType = {}));
export var FluctuationValue;
(function (FluctuationValue) {
    FluctuationValue["NO"] = "No";
    FluctuationValue["LOW"] = "Low";
    FluctuationValue["MEDIUM"] = "Medium";
    FluctuationValue["HIGH"] = "High";
    FluctuationValue["EXTREME"] = "Extreme";
})(FluctuationValue || (FluctuationValue = {}));
export var RateTimeType;
(function (RateTimeType) {
    RateTimeType["PER_MIN"] = "PerMin";
    RateTimeType["PER_HOUR"] = "PerHour";
    RateTimeType["PER_DAY"] = "PerDay";
})(RateTimeType || (RateTimeType = {}));
export var DependencyType;
(function (DependencyType) {
    DependencyType["Range"] = "Range";
    DependencyType["OutOfRange"] = "OutOfRange";
    DependencyType["Distribution"] = "Distribution";
    DependencyType["AsymmetricalDistribution"] = "AsymmetricalDistribution";
    DependencyType["NegativeDistribution"] = "NegativeDistribution";
    DependencyType["NegativeAsymmetricalDistribution"] = "NegativeAsymmetricalDistribution";
    DependencyType["Sigmoidal"] = "Sigmoidal";
    DependencyType["NegativeSigmoidal"] = "NegativeSigmoidal";
    DependencyType["Saturating"] = "Saturating";
    DependencyType["NegativeSaturating"] = "NegativeSaturating";
})(DependencyType || (DependencyType = {}));
export var DependencyPropKeys;
(function (DependencyPropKeys) {
    DependencyPropKeys["type"] = "type";
    DependencyPropKeys["mean"] = "mean";
    DependencyPropKeys["sd"] = "sd";
    DependencyPropKeys["leftSD"] = "leftSD";
    DependencyPropKeys["rightSD"] = "rightSD";
    DependencyPropKeys["from"] = "from";
    DependencyPropKeys["to"] = "to";
    DependencyPropKeys["halfEffect"] = "halfEffect";
    DependencyPropKeys["percent05"] = "percent05";
    DependencyPropKeys["percent50"] = "percent50";
    DependencyPropKeys["percent95"] = "percent95";
})(DependencyPropKeys || (DependencyPropKeys = {}));
export var DependencyRestrictionKeys;
(function (DependencyRestrictionKeys) {
    DependencyRestrictionKeys["type"] = "Type";
    DependencyRestrictionKeys["mean"] = "Mean";
    DependencyRestrictionKeys["sd"] = "SD";
    DependencyRestrictionKeys["leftSD"] = "LeftSD";
    DependencyRestrictionKeys["rightSD"] = "RightSD";
    DependencyRestrictionKeys["from"] = "From";
    DependencyRestrictionKeys["to"] = "To";
    DependencyRestrictionKeys["halfEffect"] = "HalfEffect";
    DependencyRestrictionKeys["percent05"] = "Percent05";
    DependencyRestrictionKeys["percent50"] = "Percent50";
    DependencyRestrictionKeys["percent95"] = "Percent95";
})(DependencyRestrictionKeys || (DependencyRestrictionKeys = {}));
export var CellRateChangeUnitsType;
(function (CellRateChangeUnitsType) {
    CellRateChangeUnitsType["LCellMin1"] = "LiterPerCellPerMin";
    CellRateChangeUnitsType["LCellHr1"] = "LiterPerCellPerHour";
    CellRateChangeUnitsType["LCellDay1"] = "LiterPerCellPerDay";
})(CellRateChangeUnitsType || (CellRateChangeUnitsType = {}));
export var LPerCellUnitsType;
(function (LPerCellUnitsType) {
    LPerCellUnitsType["LPerCell"] = "LPerCell";
})(LPerCellUnitsType || (LPerCellUnitsType = {}));
export var VariableReferenceType;
(function (VariableReferenceType) {
    VariableReferenceType["PROCESS"] = "Process";
    VariableReferenceType["FITTING"] = "Fitting";
    VariableReferenceType["PROCESS_AND_FITTING"] = "ProcessAndFitting";
})(VariableReferenceType || (VariableReferenceType = {}));
export var AccuracyLevel;
(function (AccuracyLevel) {
    AccuracyLevel["LOW_ACCURACY"] = "LowAccuracy";
    AccuracyLevel["MEDIUM_ACCURACY"] = "MediumAccuracy";
    AccuracyLevel["HIGH_ACCURACY"] = "HighAccuracy";
})(AccuracyLevel || (AccuracyLevel = {}));
export var RefinementRunState;
(function (RefinementRunState) {
    RefinementRunState["UNKNOWN"] = "Unknown";
    RefinementRunState["CREATED"] = "Created";
    RefinementRunState["STARTED"] = "Started";
    RefinementRunState["PAUSED"] = "Paused";
    RefinementRunState["FINISHED"] = "Finished";
    RefinementRunState["CANCELED"] = "Canceled";
    RefinementRunState["ERROR"] = "Error";
    RefinementRunState["MISSED"] = "Missed";
    RefinementRunState["FAILED_TO_START"] = "FailedToStart";
    RefinementRunState["FAILED_TO_CANCEL"] = "FailedToCancel";
    RefinementRunState["FAILED_TO_PAUSE"] = "FailedToPause";
})(RefinementRunState || (RefinementRunState = {}));
export var CellModelDisplayMode;
(function (CellModelDisplayMode) {
    CellModelDisplayMode["PREVIEW"] = "Preview";
    CellModelDisplayMode["REFINEMENT_CONFIGURATIONS"] = "RefinementConfigurations";
    CellModelDisplayMode["REFINEMENT_RESULTS"] = "RefinementResults";
})(CellModelDisplayMode || (CellModelDisplayMode = {}));
export var ChangeRefinementRunStateAction;
(function (ChangeRefinementRunStateAction) {
    ChangeRefinementRunStateAction["PAUSE"] = "pause";
    ChangeRefinementRunStateAction["RESUME"] = "resume";
    ChangeRefinementRunStateAction["STOP"] = "stop";
    ChangeRefinementRunStateAction["RESTART"] = "restart";
})(ChangeRefinementRunStateAction || (ChangeRefinementRunStateAction = {}));
var RefinementVariableValidationRules;
(function (RefinementVariableValidationRules) {
    RefinementVariableValidationRules["IncompatibleGassingRule"] = "IncompatibleGassingRule";
    RefinementVariableValidationRules["BioprocessParameterRule"] = "BioprocessParameterRule";
    RefinementVariableValidationRules["GassingPartiallyDefinedRule"] = "GassingPartiallyDefinedRule";
    RefinementVariableValidationRules["FillVolumeConflictRule"] = "FillVolumeConflictRule";
    RefinementVariableValidationRules["GasAbsVsGasPropRule"] = "GasAbsVsGasPropRule";
    RefinementVariableValidationRules["GasPropWithoutVolumeRule"] = "GasPropWithoutVolumeRule";
})(RefinementVariableValidationRules || (RefinementVariableValidationRules = {}));
